/**
 * Permission codes the Geographies & Addresses screen (FSD 1.2.8, SCR-1.2.8-GEO)
 * declares an interest in — the exact permissions the routes it reads declare:
 *
 *  - `GET /tax/jurisdictions/tree`      → `tax.jurisdiction.read` (the screen's gate)
 *  - `GET /address-rules/:country`      → `org.location.read`
 *  - `POST /locations/validate-address` → `org.location.read`
 *
 * The address-check panel is shown only to a user holding `org.location.read`;
 * without it both of its endpoints would refuse.
 */

import { ORG_PERMISSIONS } from '@/modules/org/permissions'
import { TAX_SPINE_PERMISSIONS } from '@/modules/tax/permissions'

export const GEOGRAPHY_PERMISSIONS = {
  read: TAX_SPINE_PERMISSIONS.jurisdictionRead,
  addressCheck: ORG_PERMISSIONS.locationRead,
} as const
